import { Model } from 'pinia-orm';
import Job from './Job';

export default class Domain extends Model {

    static get entity () {
        return 'domains'
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr({}),
            jobs: this.hasMany(Job, 'domain_id'),
        }
    }
}
